// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__qau6P","buttons":"RemoveExpirationActionButtons_buttons__2LBU0"};